import storage from '../../../../storage';
import logger from "../../../../logger.js";
import ExceptionBadResponse from "@/exceptions/ExceptionBadResponse.js";
// import Axios
import Axios from 'axios';
// instantiate axios
const axios = Axios.create();
// before each request
// add the current token to the next request header
axios.interceptors.request.use(
    async config => {
        let token = await storage.getToken();
        if (token) {
            config.headers.Authorization = token;
        }
        return config;
    }, error => {
        return Promise.reject(error);
    }
);
// setup query endpoint
const secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";
const endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY;

function checkSlug(i, slug) {
    let new_slug = slug;
    if(i !== 0) {
        new_slug = slug + "-" + i;
    }
    let params = {
        params: {
            slug: new_slug
        }
    };

    return axios.get(endpoint + "/api/services-new/console/v1/hotels/check-slug", params)
        .then(response => {
            if(response.data.exists) {
                // slug exists,  call again whith different slug
                return null
            } else {
                // slug ok, save hotel with diff slug
                return new_slug
            }
        })
        .catch(error => {
            if(error.response) {
                    let url = error.response.config.url?error.response.config.url:'';
                    let status = error.response.status;
                    let message = error.response.data.message ? error.response.data.message : error.response.data.error.message;
                    logger.error(`url: ${url}, status: ${status}, message: ${message}`, error.stack)
                        .then(() => null)
                } else {
                    logger.error(error.message, error.stack)
                        .then(() => null);
                }
            throw new ExceptionBadResponse();
        })
}

function updateHotel(hotel_id, hotel) {
    return axios.put(endpoint + "/api/services-new/console/v1/hotels/"+ hotel_id, hotel)
        .then(response => {
            return response.data
        })
        .catch(error => {
            if(error.response) {
                    let url = error.response.config.url?error.response.config.url:'';
                    let status = error.response.status;
                    let message = error.response.data.message ? error.response.data.message : error.response.data.error.message;
                    logger.error(`url: ${url}, status: ${status}, message: ${message}`, error.stack)
                        .then(() => null)
                } else {
                    logger.error(error.message, error.stack)
                        .then(() => null);
                }
            throw new ExceptionBadResponse();
        })
}

function getHotel(hotel_id) {
    return axios.get(endpoint + "/api/services-new/console/v1/hotels/" + hotel_id)
        .then(response => {
            return response.data
        })
        .catch(error => {
            if(error.response) {
                    let url = error.response.config.url?error.response.config.url:'';
                    let status = error.response.status;
                    let message = error.response.data.message ? error.response.data.message : error.response.data.error.message;
                    logger.error(`url: ${url}, status: ${status}, message: ${message}`, error.stack)
                        .then(() => null)
                } else {
                    logger.error(error.message, error.stack)
                        .then(() => null);
                }
            throw new ExceptionBadResponse();
        })
}

function createHotel(hotel) {
    return axios.post(endpoint + "/api/services-new/console/v1/hotels/", hotel)
        .then(response => {
            return response.data
        })
        .catch(error => {
            if(error.response) {
                    let url = error.response.config.url?error.response.config.url:'';
                    let status = error.response.status;
                    let message = error.response.data.message ? error.response.data.message : error.response.data.error.message;
                    logger.error(`url: ${url}, status: ${status}, message: ${message}`, error.stack)
                        .then(() => null)
                } else {
                    logger.error(error.message, error.stack)
                        .then(() => null);
                }
            throw new ExceptionBadResponse();
        })
}

function createPolicy(policy) {
    return axios.post(endpoint + '/api/services-new/console/v1/cancellation-policies/', policy)
        .then(response => {
            return response.data
        })
        .catch(error => {
            if(error.response) {
                    let url = error.response.config.url?error.response.config.url:'';
                    let status = error.response.status;
                    let message = error.response.data.message ? error.response.data.message : error.response.data.error.message;
                    logger.error(`url: ${url}, status: ${status}, message: ${message}`, error.stack)
                        .then(() => null)
                } else {
                    logger.error(error.message, error.stack)
                        .then(() => null);
                }
            throw new ExceptionBadResponse();
        });
}

function createRatePlan(rate_plan) {
    return axios.post(endpoint + '/api/services-new/console/v1/rate-plans', rate_plan)
        .then(response => {
            return response.data
        })
        .catch(error => {
            if(error.response) {
                    let url = error.response.config.url?error.response.config.url:'';
                    let status = error.response.status;
                    let message = error.response.data.message ? error.response.data.message : error.response.data.error.message;
                    logger.error(`url: ${url}, status: ${status}, message: ${message}`, error.stack)
                        .then(() => null)
                } else {
                    logger.error(error.message, error.stack)
                        .then(() => null);
                }
            throw new ExceptionBadResponse();
        });
}

function createRoom(room) {
    return axios.post(endpoint + '/api/services-new/console/v1/room-types/', room)
        .then(response => {})
        .catch(error => {
            if(error.response) {
                    let url = error.response.config.url?error.response.config.url:'';
                    let status = error.response.status;
                    let message = error.response.data.message ? error.response.data.message : error.response.data.error.message;
                    logger.error(`url: ${url}, status: ${status}, message: ${message}`, error.stack)
                        .then(() => null)
                } else {
                    logger.error(error.message, error.stack)
                        .then(() => null);
                }
            throw new ExceptionBadResponse();
        });
}

export default {
  checkSlug,
  getHotel,
  updateHotel,
  createHotel,
  createPolicy,
  createRatePlan,
  createRoom,
};
